import React, { Component } from "react";
import { Api } from "../../../app-controller.js";

class ModalSolicitudMovimiento extends Component {
  render() {
    return (
      <>
        <div>
          {/*  <fieldset className="panel"> */}
          {/* <legend>Certificado de exportación</legend> */}
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div id="detalleCertificado">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Trámite</div>

                          <div className="stats-desc">
                            <h5>Casos Especiales</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Tipo de importación</div>

                          <div className="stats-desc">
                            <h5>
                              {
                                this.props.state.caso_especial.tipo_importacion
                                  .descripcion
                              }
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Estado</div>

                          <div className="stats-desc">
                            <h5>
                              {
                                this.props.state.solicitud_ce.estatus
                                  .descripcion
                              }
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                        <div className="stats-icon stats-icon-lg">
                          <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                        </div>
                        <div className="stats-content">
                          <div className="stats-title">Fecha</div>

                          <div className="stats-desc">
                            <h5>
                              {this.props.state.solicitud_ce.fecha_solicitud
                                .substr(0, 10)
                                .split("-")
                                .reverse()
                                .join("/")}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <fieldset>
                    <legend>DATOS IMPORTACIÓN</legend>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Tipo:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .tipo_producto_importacion
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>Guía aréa:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .guia_area
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>No.Factura:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .no_factura
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Importador:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .importador_razon_social
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Código DISAAN importador:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .codigo_disaan_importador
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-8">
                        <div className="form-group">
                          <label>Fabricante:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .fabricante_razon_social
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>Código DISAAN fabricante:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .codigo_disaan_fabricante
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>País de origen:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .pais_origen_nombre
                            }
                          </div>
                        </div>
                          </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>País de procedencia:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .pais_procedencia_nombre
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Solicitado por:</label>
                          <div className="form-control">
                            {
                              this.props.state.caso_especial.datos_importacion
                                .nombre_solicitante
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <div className="col-lg-12">
                        {this.props.state.caso_especial.tipo_importacion_id ===
                        "7" ? (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">Materia Prima</th>
                                <th className="text-center">País de origen</th>
                                <th className="text-center">Fabricante</th>
                                <th className="text-center">Presentación</th>
                                <th className="text-center">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.caso_especial.productos.length >
                              0 ? (
                                this.props.state.caso_especial.productos.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center" width={"20%"}>
                                        {item.nombre_materia_prima}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.pais_origen_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.fabricante_razon_social}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.presentacion}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.cantidad}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No se encontraorn productos listados
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <table className="table table-striped mb-0 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  Nombre comercial
                                </th>
                                <th className="text-center">Presentación</th>
                                <th className="text-center">Especie</th>
                                <th className="text-center">Categoría</th>
                                <th className="text-center">País origen</th>
                                <th className="text-center">Cantidad</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.caso_especial.productos.length >
                              0 ? (
                                this.props.state.caso_especial.productos.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center" width={"20%"}>
                                        {item.nombre_comercial}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.presentacion}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.especie_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.categoria_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.pais_origen_nombre}
                                      </td>
                                      <td className="text-center" width={"20%"}>
                                        {item.cantidad}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    No se encontraorn productos listados
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    </div>

                    <br />

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Petición:</label>
                          <textarea
                            className="form-control"
                            defaultValue={
                              this.props.state.caso_especial.datos_importacion
                                .peticion
                            }
                            readOnly
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  {!["1", "7", "8"].includes(
                    this.props.state.caso_especial.tipo_importacion_id
                  ) ? (
                    <fieldset>
                      <legend>DATOS ESTABLECIMIENTO</legend>

                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Razón social:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .razon_social
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Dirección:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .direccion
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Cédula RUC:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .cedula_ruc
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Correo electrónico:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .correo_electronico
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Teléfono:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .telefono
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>Representante legal:</label>
                            <div className="form-control">
                              {
                                this.props.state.caso_especial.establecimiento
                                  .representante_legal
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  ) : null}

                  {["4", "5", "9"].includes(
                    this.props.state.solicitud_ce.estatus_tramite_id
                  ) &&
                  ["1", "7", "8"].includes(
                    this.props.state.caso_especial.tipo_importacion_id
                  ) ? (
                    <fieldset>
                      <legend>DOCUMENTOS</legend>

                      <div className="table-responsive">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th className="text-center">Vista previa</th>
                              <th className="text-center">Documento</th>
                              <th className="text-center">Fecha carga</th>
                              <th className="text-center">Estatus</th>
                              <th className="text-center">Fecha aprobación</th>
                              <th className="text-center">Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.caso_especial.documentacion
                              .length > 0
                              ? this.props.state.caso_especial.documentacion.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="text-center">
                                        <img
                                          alt="Vista previa"
                                          className="rounded btn"
                                          data-file={
                                            Api.url +
                                            `app/documentoCE/?id=${
                                              item.id
                                            }&tipo_documento=${item.documento_nombre.toUpperCase()}&folio_solicitud=${
                                              item.folio_solicitud
                                            }`
                                          }
                                          onClick={this.props.handlePrevia}
                                          width="60"
                                          src={
                                            Api.url +
                                            `app/documentoCE/?id=${item.id}&thumb=1`
                                          }
                                        />
                                      </td>
                                      <td className="text-center">
                                        {item.documento_nombre.toUpperCase()}
                                      </td>
                                      <td className="text-center">
                                        {item.fecha_subida}
                                      </td>
                                      <td className="text-center">
                                        {item.aprobado === "1"
                                          ? "APROBADA"
                                          : item.aprobado === "0"
                                          ? "RECHAZADA"
                                          : "PENDIENTE"}
                                      </td>
                                      <td className="text-center">
                                        {item.fecha_aprueba}
                                      </td>
                                      <td className="text-center">
                                        <div className="btn-group">
                                          <a
                                            href={
                                              Api.url +
                                              `app/documentoCE/?id=${item.id}&download=1&tipo_documento=${item.documento_nombre}&folio_solicitud=${item.folio_solicitud}`
                                            }
                                            className="btn btn-primary"
                                          >
                                            <i className="fas fa-file-download"></i>
                                          </a>
                                          <button
                                            type="button"
                                            id={item.id}
                                            onClick={
                                              this.props
                                                .handleCasoEspecialDocumentoEstatusChange
                                            }
                                            data-estatus="0"
                                            title={`RECHAZAR ${item.documento_nombre}`}
                                            className="btn btn-danger"
                                            disabled={["0", "1"].includes(
                                              item.aprobado
                                            )}
                                          >
                                            <i
                                              id={item.id}
                                              className="fas fa-ban"
                                              data-estatus="0"
                                            ></i>{" "}
                                            Rechazar
                                          </button>
                                          <button
                                            id={item.id}
                                            onClick={
                                              this.props
                                                .handleCasoEspecialDocumentoEstatusChange
                                            }
                                            type="button"
                                            data-estatus="1"
                                            title={`ACEPTAR ${item.documento_nombre}`}
                                            disabled={["0", "1"].includes(
                                              item.aprobado
                                            )}
                                            className="btn btn-success"
                                          >
                                            <i
                                              id={item.id}
                                              data-estatus="1"
                                              className="fas fa-check"
                                            ></i>{" "}
                                            Aprobar
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )
                              : null}
                          </tbody>
                        </table>
                      </div>
                    </fieldset>
                  ) : null}

                  {["5", "9"].includes(
                    this.props.state.solicitud_ce.estatus_tramite_id
                  ) &&
                  ["1", "7", "8"].includes(
                    this.props.state.caso_especial.tipo_importacion_id
                  ) ? (
                    <fieldset>
                      <legend>DATOS DE IMPORTACIÓN ADICIONALES</legend>

                      <div className="row">
                        {this.props.state.solicitud_ce.estatus_tramite_id ===
                        "5" ? (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="importacion_texto">
                                Autorizo importación de:
                              </label>

                              <div className="form-control">
                                {
                                  this.props.state.caso_especial
                                    .datos_importacion.importacion_texto
                                }
                              </div>
                            </div>
                          </div>
                        ) : this.props.state.solicitud_ce.estatus_tramite_id ===
                          "9" ? (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="importacion_texto">
                                Autorizo importación de:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="importacion_texto"
                                value={
                                  this.props.state.importacion.importacion_texto
                                }
                                onChange={
                                  this.props
                                    .handleImportacionAdicionalDataChange
                                }
                                className="form-control"
                                id="importacion_texto"
                                placeholder="Ingrese texto de importación a autorizar"
                              />
                              <div
                                className="invalid-feedback"
                                style={{ display: "none" }}
                                id="importacion_texto-error"
                              ></div>
                            </div>
                          </div>
                        ) : null}

                        {this.props.state.solicitud_ce.estatus_tramite_id ===
                        "5" ? (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="fines_texto">
                                Con fines de:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="form-control">
                                {
                                  this.props.state.caso_especial
                                    .datos_importacion.fines_texto
                                }
                              </div>
                            </div>
                          </div>
                        ) : ["9"].includes(
                            this.props.state.solicitud_ce.estatus_tramite_id
                          ) ? (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="fines_texto">
                                Con fines de:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="fines_texto"
                                value={this.props.state.importacion.fines_texto}
                                onChange={
                                  this.props
                                    .handleImportacionAdicionalDataChange
                                }
                                className="form-control"
                                id="fines_texto"
                                placeholder="Ingrese motivo de importación"
                              />
                              <div
                                className="invalid-feedback"
                                style={{ display: "none" }}
                                id="fines_texto-error"
                              ></div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </fieldset>
                  ) : null}

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="btn-group  pull-left">
                        <button
                          className="btn btn-danger "
                          onClick={() => {
                            this.props.closeModalCasoEspecial();
                          }}
                        >
                          Regresar
                        </button>
                      </div>

                      {["4", "5", "9"].includes(
                        this.props.state.solicitud_ce.estatus_tramite_id
                      ) &&
                      ["1", "7", "8"].includes(
                        this.props.state.caso_especial.tipo_importacion_id
                      ) ? (
                        <div className="btn-group pull-right col-md-4">
                          {!this.props.state.caso_especial
                            .todosDocsAprobados ? (
                            <button
                              onClick={this.props.handleCasoEspecialEstatus}
                              value="4"
                              data-caso_especial_id={
                                this.props.state.caso_especial.id
                              }
                              id="rechazar_mov"
                              className="btn btn-danger"
                              disabled={["4", "5"].includes(
                                this.props.state.solicitud_ce.estatus_tramite_id
                              )}
                            >
                              Rechazar
                            </button>
                          ) : (
                            <button
                              onClick={this.props.handleCasoEspecialEstatus}
                              value="5"
                              disabled={["4", "5"].includes(
                                this.props.state.solicitud_ce.estatus_tramite_id
                              )}
                              data-caso_especial_id={
                                this.props.state.caso_especial.id
                              }
                              id="aprobar_mov"
                              className="btn btn-success "
                            >
                              Aceptar
                            </button>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 
              </fieldset> */}
        </div>
      </>
    );
  }
}

export default ModalSolicitudMovimiento;
